import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  {
    path: 'books',
    loadChildren: () => import('./books/books.module').then( m => m.BooksPageModule)
  },
  {
    path: 'question-test',
    loadChildren: () => import('./question-test/question-test.module').then( m => m.QuestionTestPageModule)
  },
  {
    path: 'question-result',
    loadChildren: () => import('./question-result/question-result.module').then( m => m.QuestionResultPageModule)
  },
  {
    path: 'learncard',
    loadChildren: () => import('./learncard/learncard.module').then( m => m.LearncardPageModule)
  },
  {
    path: 'topics-list',
    loadChildren: () => import('./topics-list/topics-list.module').then( m => m.TopicsListPageModule)
  },
  {
    path: 'quizz-view',
    loadChildren: () => import('./quizz-view/quizz-view.module').then( m => m.QuizzViewPageModule)
  },
  {
    path: 'courses',
    loadChildren: () => import('./courses/courses.module').then( m => m.CoursesPageModule)
  },
  {
    path: 'courses/:bookName',
    loadChildren: () => import('./courses/courses.module').then( m => m.CoursesPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
